/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorList,
  PasswordRestoreTokenInput,
  ResetPassword,
} from '../models';
import {
    ErrorListFromJSON,
    ErrorListToJSON,
    PasswordRestoreTokenInputFromJSON,
    PasswordRestoreTokenInputToJSON,
    ResetPasswordFromJSON,
    ResetPasswordToJSON,
} from '../models';

export interface DoResetPasswordRequest {
    baseSiteId: string;
    resetPassword: ResetPassword;
    sapCommerceCloudCustomerId?: string;
}

export interface DoRestorePasswordRequest {
    baseSiteId: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface SendPasswordRestoreTokenRequest {
    baseSiteId: string;
    passwordRestoreTokenInput: PasswordRestoreTokenInput;
    sapCommerceCloudCustomerId?: string;
}

/**
 * ForgottenPasswordsApi - interface
 * 
 * @export
 * @interface ForgottenPasswordsApiInterface
 */
export interface ForgottenPasswordsApiInterface {
    /**
     * Reset password after customer\'s clicked forgotten password link. A new password needs to be provided.
     * @summary Resets a forgotten password.
     * @param {string} baseSiteId Base site identifier
     * @param {ResetPassword} resetPassword 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForgottenPasswordsApiInterface
     */
    doResetPasswordRaw(requestParameters: DoResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Reset password after customer\'s clicked forgotten password link. A new password needs to be provided.
     * Resets a forgotten password.
     */
    doResetPassword(requestParameters: DoResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates a token so that customers can restore their forgotten passwords. This endpoint is deprecated in the 2211.24 update and its deletion is planned. Please use the POST /{baseSiteId}/passwordRestoreToken instead.
     * @summary Creates a token to restore a forgotten password.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId Customer\&#39;s user id. Customer user id is case insensitive.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ForgottenPasswordsApiInterface
     */
    doRestorePasswordRaw(requestParameters: DoRestorePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Creates a token so that customers can restore their forgotten passwords. This endpoint is deprecated in the 2211.24 update and its deletion is planned. Please use the POST /{baseSiteId}/passwordRestoreToken instead.
     * Creates a token to restore a forgotten password.
     */
    doRestorePassword(requestParameters: DoRestorePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates and sends a token that is used to restore a forgotten password in a following asynchronous customer communication. This endpoint is added in the 2211.24 update.
     * @summary Creates and sends a token to restore a forgotten password.
     * @param {string} baseSiteId Base site identifier
     * @param {PasswordRestoreTokenInput} passwordRestoreTokenInput 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForgottenPasswordsApiInterface
     */
    sendPasswordRestoreTokenRaw(requestParameters: SendPasswordRestoreTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Creates and sends a token that is used to restore a forgotten password in a following asynchronous customer communication. This endpoint is added in the 2211.24 update.
     * Creates and sends a token to restore a forgotten password.
     */
    sendPasswordRestoreToken(requestParameters: SendPasswordRestoreTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ForgottenPasswordsApi extends runtime.BaseAPI implements ForgottenPasswordsApiInterface {

    /**
     * Reset password after customer\'s clicked forgotten password link. A new password needs to be provided.
     * Resets a forgotten password.
     */
    async doResetPasswordRaw(requestParameters: DoResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling doResetPassword.');
        }

        if (requestParameters.resetPassword === null || requestParameters.resetPassword === undefined) {
            throw new runtime.RequiredError('resetPassword','Required parameter requestParameters.resetPassword was null or undefined when calling doResetPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/resetpassword`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordToJSON(requestParameters.resetPassword),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reset password after customer\'s clicked forgotten password link. A new password needs to be provided.
     * Resets a forgotten password.
     */
    async doResetPassword(requestParameters: DoResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.doResetPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a token so that customers can restore their forgotten passwords. This endpoint is deprecated in the 2211.24 update and its deletion is planned. Please use the POST /{baseSiteId}/passwordRestoreToken instead.
     * Creates a token to restore a forgotten password.
     */
    async doRestorePasswordRaw(requestParameters: DoRestorePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling doRestorePassword.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling doRestorePassword.');
        }

        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/forgottenpasswordtokens`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a token so that customers can restore their forgotten passwords. This endpoint is deprecated in the 2211.24 update and its deletion is planned. Please use the POST /{baseSiteId}/passwordRestoreToken instead.
     * Creates a token to restore a forgotten password.
     */
    async doRestorePassword(requestParameters: DoRestorePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.doRestorePasswordRaw(requestParameters, initOverrides);
    }

    /**
     * Creates and sends a token that is used to restore a forgotten password in a following asynchronous customer communication. This endpoint is added in the 2211.24 update.
     * Creates and sends a token to restore a forgotten password.
     */
    async sendPasswordRestoreTokenRaw(requestParameters: SendPasswordRestoreTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling sendPasswordRestoreToken.');
        }

        if (requestParameters.passwordRestoreTokenInput === null || requestParameters.passwordRestoreTokenInput === undefined) {
            throw new runtime.RequiredError('passwordRestoreTokenInput','Required parameter requestParameters.passwordRestoreTokenInput was null or undefined when calling sendPasswordRestoreToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/passwordRestoreToken`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordRestoreTokenInputToJSON(requestParameters.passwordRestoreTokenInput),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates and sends a token that is used to restore a forgotten password in a following asynchronous customer communication. This endpoint is added in the 2211.24 update.
     * Creates and sends a token to restore a forgotten password.
     */
    async sendPasswordRestoreToken(requestParameters: SendPasswordRestoreTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendPasswordRestoreTokenRaw(requestParameters, initOverrides);
    }

}
